import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

const ConferenceHub = (): unknown => {
    return import(/* webpackPrefetch: true */ './conference-hub-page.vue');
};

export const conferenceHubRoute: RouteRecordRaw = {
    ...ROUTE_DATA.CONFERENCE_HUB_PAGE,
    components: {
        main: ConferenceHub
    }
};
